<template>
  <div class="AD pt7 padding5 bc-white" v-title data-title="按钮">
    <div v-for="(btn, index) in btns" :key="index" class="pb7">
      <div class="row align-items-center pb5">
        <div class="col-6">
          <van-field v-model="btn.btnName" placeholder="按钮名称"/>
        </div>
        <div class="flex-1 pl2">
          <van-field v-model="btn.btnLink" placeholder="请输入链接"/>
        </div>
      </div>
      <div class="row justify-content-around">
        <van-button plain type="danger" class="btn-common"
            @click.stop="delbottombuttons(btn, index)">删除按钮</van-button>
        <van-button plain type="info" class="btn-common"
            @click.stop="savebottombuttons(btn, index)">保存按钮</van-button>
      </div>
    </div>
    <van-button @click="addLine" class="btn-common" type="info"><van-icon name="plus"/> 增加一栏</van-button>
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <!-- <van-button @click="saveNotice" class="btn-common" type="info">保存</van-button> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getbottombuttons, addbottombuttons,
  updatebottombuttons, delbottombuttons,
} from '../network/NetworkAccessor';

export default Vue.extend({
  name: 'AD',
  components: {},
  data() {
    return {
      loading: false,
      btns: [],
    };
  },
  methods: {
    delbottombuttons(item, index) {
      if (index < 0) {
        return;
      }
      if (!item.id) {
        this.btns.splice(index, 1);
        return;
      }
      sendRequest(delbottombuttons, item).then((res) => {
        this.btns.splice(index, 1);
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    savebottombuttons(item = {}, index) {
      if (!item.btnName) {
        this.$dialog.alert({
          message: '请输入按钮名称',
        });
      }
      Object.assign(item, {
        btnSort: index,
      });
      sendRequest(item.id ? updatebottombuttons : addbottombuttons, item).then((res) => {
        this.$dialog.alert({
          message: '保存成功',
        });
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    addLine() {
      this.btns.push(
        {
          btnName: '',
          btnLink: '',
        },
      );
    },
    getBottomButtons() {
      sendRequest(getbottombuttons).then((res) => {
        this.btns = res;
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    back() {
      this.$router.back();
    },
  },
  created() {
    this.getBottomButtons();
  },
});
</script>
<style scoped>
  .AD {
    min-height: 100vh;
  }
  .add {
    width: 200px;
    height: 100px;
    line-height: 110px;
    border: 1px dashed #2c2c2c;
    margin: 0 auto;
  }
</style>
